import { ETourId, type ITourConfig } from '../types';

/**
 * Intro tour for chapter 3 "Monitor".
 *
 * Runs on the automation details page and highlights the
 * "Back to automations" breadcrumb to orient the user toward the
 * monitoring experience before they navigate to the automations list.
 */
export const monitorIntroTour: ITourConfig = {
  id: ETourId.MONITOR_INTRO,
  steps: [
    {
      id: 'monitor-intro-breadcrumb-highlight',
      target: '[data-tour-id="back-to-automations"]',
      titleKey: 'tours.monitorIntro.breadcrumbHighlight.title',
      descriptionKey: 'tours.monitorIntro.breadcrumbHighlight.description',
      finishLabelKey: 'tours.monitorIntro.breadcrumbHighlight.finishLabel',
      position: 'bottomLeft',
    },
  ],
  namespace: 'tours',
  variant: 'default',
  size: 'sm',
  analytics: {
    enabled: true,
    eventPrefix: 'tour_monitor_intro',
    metadata: {
      tourName: 'Monitor Intro',
    },
  },
  persistence: {
    strategy: 'localStorage',
  },
};
